import { Illustration } from '@storeblocks/icon';
import Surface from '@storeblocks/surface';
import React from 'react';

import { CallUsMessageHtml } from 'Components/CallUsMessageHtml';
import { AgreementCode } from 'Constants/agreementCodes.constants';
import { getAppText } from 'Utils/text';
import { CancelSurveyReason } from '../cancelForm.constants';
import {
  Container,
  IllustrationContainer,
  TextContainer,
  Title,
} from '../cancelForm.styles';
import { getPartnerPhoneNumberVariable } from '../EmailCancellation/emailCancellationForm.helpers';

type Props = {
  cancellationReason: CancelSurveyReason | null;
  agreementProduct: AgreementCode;
};

export const ReconsiderationPrompt = ({
  cancellationReason,
  agreementProduct,
}: Props) => {
  if (
    !cancellationReason ||
    cancellationReason === CancelSurveyReason.OTHER_REASON
  ) {
    return null;
  }

  const title = getAppText(
    `cancelInsurance.reconsiderationPrompt.${cancellationReason}.title`,
  );

  const message = getAppText(
    `cancelInsurance.reconsiderationPrompt.${cancellationReason}.message`,
  );

  return (
    <Surface variant="border">
      <Container>
        <TextContainer>
          <Title>{title}</Title>
          <CallUsMessageHtml
            customMessage={message}
            inlineCustomMessage={false}
            phoneNumber={getPartnerPhoneNumberVariable(agreementProduct)}
          />
        </TextContainer>
        <IllustrationContainer>
          <Illustration
            width="120px"
            height="150px"
            name="customer-service-man"
          />
        </IllustrationContainer>
      </Container>
    </Surface>
  );
};
